import React from 'react';
import Article from './Article';
import useArticle from '../../../hooks/useArticle';

function Index() {
  const articleProps = useArticle();
  return <Article articleHook={articleProps} />;
}

export default Index;
